import React from 'react'
import advertsList from 'constants/shared/adverts'
import Adverts from '../presentational/Adverts'

const AdvertsContainer = () => {
    return <Adverts list={advertsList} />
}

export default AdvertsContainer
